import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import Grid from "components/common/Grid";
import { makeStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Link from "components/common/Link";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Paper from "@mui/material/Paper";
import Refund from "../Admin/Note/Refund";
import CancelationCharges from "../Admin/Note/CancelationCharges";

const VendorConfig = ({
  handlePriceClickOpen,
  handleDistanceClickOpen,
  handleClickOpen,
  data,
  config,
}) => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.grandParent}>
        <Box sx={{ display: "flex" }}>
          <Link to="/vendor">
            <ArrowBackIcon
              sx={{
                fontSize: "20px",
                margin: "17px 0px 10px 0px",
                color: "#707070",
              }}
            />
          </Link>
          <Text
            variant="h4"
            component="div"
            gutterBottom
            sx={{ margin: "15px 10px 25px 10px", color: "#707070" }}
          >
            {config}
          </Text>
        </Box>
        <Grid item xs={12}>
          <Stack spacing={1}>
            <Paper elevation={0}>
              <Stack sx={{ p: 5 }} spacing={1} direction={"row"}>
                <Typography
                  sx={{
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "19px",
                    color: "#111111",
                  }}
                >
                  Cancellation period (hr)
                </Typography>
                <EditOutlinedIcon
                  onClick={() =>
                    handleClickOpen(data?.cancellation_time, data?.vendor_id)
                  }
                  sx={{
                    marginLeft: "5px",
                    width: "18px",
                    height: "18px",
                    marginTop: "1px",
                    color: "#000000",
                    cursor: "pointer",
                  }}
                />
                <Refund />
              </Stack>

              <Stack
                sx={{ p: 5 }}
                spacing={1}
                direction={"row"}
                marginTop="-4rem"
              >
                <Box>
                  <Text
                    variant="h1"
                    sx={{
                      width: "103px",
                      height: "39px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: "25px",
                      lineHeight: "39px",
                      color: "#111111",
                    }}
                  >
                    {data?.cancellation_time} hour
                  </Text>
                </Box>
              </Stack>
              <Stack
                sx={{ p: 5 }}
                spacing={1}
                direction={"row"}
                marginTop="-3rem"
              >
                <Typography
                  sx={{
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "19px",
                    color: "#111111",
                  }}
                >
                  Grace time
                </Typography>
                <EditOutlinedIcon
                  onClick={() =>
                    handlePriceClickOpen(data?.grace_time, data?.vendor_id)
                  }
                  sx={{
                    marginLeft: "5px",
                    width: "18px",
                    height: "18px",
                    marginTop: "1px",
                    color: "#000000",
                    cursor: "pointer",
                  }}
                />
                <CancelationCharges />
              </Stack>

              <Stack sx={{ p: 5 }} marginTop="-4rem">
                <Box display="flex">
                  <Text
                    variant="h1"
                    sx={{
                      width: "auto",
                      height: "39px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: "25px",
                      lineHeight: "39px",
                      color: "#111111",
                      marginLeft: "1px",
                      marginRight: "4rem",
                    }}
                  >
                    {data?.grace_time} mins
                  </Text>
                </Box>
              </Stack>

              <Stack
                sx={{ p: 5 }}
                spacing={1}
                direction={"row"}
                marginTop="-3rem"
              >
                <Box display="flex">
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "19px",
                      color: "#111111",
                    }}
                  >
                    Advance fee charges
                  </Typography>
                  <EditOutlinedIcon
                    onClick={() =>
                      handleDistanceClickOpen(
                        data?.advance_charges,
                        data?.vendor_id
                      )
                    }
                    sx={{
                      marginLeft: "5px",
                      width: "18px",
                      height: "18px",
                      marginTop: "1px",
                      color: "#000000",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              </Stack>

              <Stack
                sx={{ p: 5 }}
                spacing={1}
                direction={"row"}
                marginTop="-4rem"
              >
                <Box>
                  <Text
                    variant="h1"
                    sx={{
                      width: "115px",
                      height: "39px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: "25px",
                      lineHeight: "39px",
                      color: "#111111",
                    }}
                  >
                    {data?.advance_charges} %
                  </Text>
                </Box>
              </Stack>

              <Stack sx={{ p: 5 }} spacing={1}></Stack>
            </Paper>
          </Stack>
        </Grid>
      </Box>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  grandParent: {
    padding: "1rem",
    "@media (max-width:768px)": {
      padding: "0px",
    },
  },
}));

export default VendorConfig;
